import { Button } from 'react-bootstrap'
import styled from 'styled-components'

const MintButton = styled(Button)`
    font-family: ${properties => properties.theme.variables.fontFamily.headline};
    font-weight: 600;
    width: 100%;
    margin: 8px 0;
    height: 55px;
    letter-spacing: -0.32px;
    font-size: 16px;
    cursor: pointer;
    line-height: 14px;

    background: ${properties =>
        properties.inverse ? properties.theme.variables.colorBackground : properties.theme.variables.colorPrimary};
    border: 1px solid
        ${properties =>
            properties.inverse ? properties.theme.variables.colorPrimary : properties.theme.variables.colorBackground};
    box-sizing: border-box;
    border-radius: 27px;
    box-shadow: ${properties => properties.theme.variables.boxShadow};
    text-transform: uppercase;
    color: ${properties =>
        properties.inverse ? properties.theme.variables.colorPrimary : properties.theme.variables.colorBackground};
    &:hover {
        color: ${properties =>
            properties.inverse ? properties.theme.variables.colorPrimary : properties.theme.variables.colorBackground};
        background-color: ${properties =>
            properties.inverse ? properties.theme.variables.colorBackground : properties.theme.variables.colorPrimary};
        border-color: ${properties =>
            properties.inverse ? properties.theme.variables.colorBackground : properties.theme.variables.colorPrimary};
        opacity: 0.8;
    }
    &:focus {
        color: ${properties =>
            properties.inverse ? properties.theme.variables.colorPrimary : properties.theme.variables.colorBackground};
        background-color: ${properties =>
            properties.inverse ? properties.theme.variables.colorBackground : properties.theme.variables.colorPrimary};
        border-color: ${properties =>
            properties.inverse ? properties.theme.variables.colorBackground : properties.theme.variables.colorPrimary};
        /* box-shadow: ${properties => properties.theme.variables.boxShadow}; */
        box-shadow: 0 0 0 0.25rem rgb(0 214 50 / 50%);
    }
    &:active {
        color: ${properties =>
            properties.inverse ? properties.theme.variables.colorPrimary : properties.theme.variables.colorBackground};
        background-color: ${properties =>
            properties.inverse ? properties.theme.variables.colorBackground : properties.theme.variables.colorPrimary};
        border-color: ${properties =>
            properties.inverse ? properties.theme.variables.colorBackground : properties.theme.variables.colorPrimary};
    }
    &:active:focus {
        /* box-shadow: ${properties => properties.theme.variables.boxShadow}; */
        box-shadow: 0 0 0 0.25rem rgb(0 214 50 / 50%);
    }
    &:disabled {
        background-color: ${properties => properties.theme.variables.colorGray.secondary};
        border-color: ${properties => properties.theme.variables.colorGray.secondary};
    }
    @media only screen and (min-width: 810px) {
        height: 60px;
    }
`

export default MintButton
